/* Gotta v2: presentation hooks only. Do not refill, re-sort, filter or recount cards.
 * File name is preserved for compatibility with the existing theme.
 */
(() => {
  'use strict';
  if (window.GottaCardEnhancements) return;
  function refreshSwatches() {
    document.querySelectorAll('#product-grid .color__container').forEach((container) => {
      const parent = container.closest('.color_swatches__container');
      const show = () => parent?.classList.remove('color_swatches__container--hidden');
      const count = container.querySelectorAll('.swatch_item').length;
      if (!count) return;
      if (count <= 4) {
        container.classList.add('color__container--no-carousel');
        show();
        return;
      }
      if (container.classList.contains('flickity-enabled')) { show(); return; }
      if (container.dataset.gottaSwatchesPending === 'true') return;
      container.dataset.gottaSwatchesPending = 'true';
      const initialize = () => {
        if (!container.isConnected) return;
        if (container.classList.contains('flickity-enabled')) { show(); return; }
        try {
          if (typeof window.Flickity === 'function') {
            new window.Flickity(container, {
              cellAlign: 'left', prevNextButtons: true, pageDots: false,
              draggable: true, initialIndex: 0, on: { ready: show }
            });
          } else container.classList.add('color__container--no-carousel');
        } catch (error) {
          console.warn('[Gotta swatches]', error.message);
          container.classList.add('color__container--no-carousel');
        }
        show();
      };
      if (typeof window.loadFlickity === 'function') window.loadFlickity().then(initialize).catch(() => { container.classList.add('color__container--no-carousel'); show(); });
      else initialize();
    });
  }
  function refresh() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    try { if (typeof normalInfo === 'function') normalInfo(); } catch (error) { console.warn('[Gotta delivery]', error.message); }
    refreshSwatches();
  }
  window.GottaCardEnhancements = { refresh };
  // Preserve the existing public hooks, but never mutate the set of products.
  window.refreshAvailableCollectionGrid = refresh;
  if (typeof window.refreshColorSwatches !== 'function') window.refreshColorSwatches = refreshSwatches;
  document.addEventListener('gotta:facets:rendered', refresh);
  document.addEventListener('gotta:products:appended', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
